module.exports = __webpack_public_path__ + "img/0-sm.95060e20.jpg";